<section class="wepal-light-estimate pb-5" *ngIf="transportFormGroup">
  <form>
    <div class="row no-gutters px-2 px-md-0 justify-content-center">
      <div class="pr-md-1 col-12 col-md-4 col-lg-3">
        <jhi-wepal-input-gplace
          [direction]="'left'"
          [addressForm]="transportFormGroup.controls.pickupAddress"
          [id]="'pickupAddressAutofill'"
          [label]="'LABEL.PICKUP_ADDRESS' | translate"
          [verify]="false"
          [placeholder]="'WEPAL_LIGHT_ESTIMATE.PLACEHOLDER.PICKUP' | translate"
          data-id-cypress="pickup-address"
        >
        </jhi-wepal-input-gplace>
      </div>
      <div class="p-md-0 pr-md-1 col-12 col-md-4 col-lg-3">
        <jhi-wepal-input-gplace
          [direction]="'all'"
          [addressForm]="transportFormGroup.controls.deliveryAddress"
          [id]="'deliveryAddressAutofill'"
          [label]="'LABEL.DELIVERY_ADDRESS' | translate"
          [verify]="false"
          [placeholder]="'WEPAL_LIGHT_ESTIMATE.PLACEHOLDER.DELIVERY' | translate"
          data-id-cypress="delivery-address"
        >
        </jhi-wepal-input-gplace>
      </div>
      <div class="p-md-0 col-12 form-group col-md-auto">
        <button
          class="m-0 search-button"
          type="button"
          (click)="initTransportItem()"
          data-id-cypress="search-btn"
          [disabled]="transportFormGroup.getAngularForm().controls['items']?.value?.length > 0"
        >
          <mdb-icon fas size="lg" icon="search"></mdb-icon>
        </button>
      </div>
    </div>
  </form>

  <section id="section-merchandises">
    <div class="px-2">
      <div class="mb-3 p-3 mx-auto transport-item-line bg-white max-width-50em" *ngFor="let transportItemForm of transportFormGroup.controls.items; let index = index">
        <jhi-bary-transport-item-line
          [transportFormGroup]="transportFormGroup"
          [item]="getValueForTransportItem(transportItemForm)"
          (deleteEvent)="handleRemove(index)"
          (editEvent)="initTransportItem(index)"
        ></jhi-bary-transport-item-line>
      </div>
    </div>
    <div class="row no-gutters justify-content-center" *ngIf="transportFormGroup.showAddItem()">
      <div class="col-12 col-md-8 col-xl-6">
        <jhi-bary-specific-button class="col-12 add-merchandise" type="addMerchandise" (clickEvent)="initTransportItem()"></jhi-bary-specific-button>
      </div>
    </div>
  </section>
</section>
<section class="section-offer" id="section-offer">
  <div *ngIf="!loadingData && quotationOK && offerEstimations.length === 0" class="text-center pb-3 my-5">
    <hr class="bary-hr" />
    <p>{{ 'WEPAL_LIGHT_ESTIMATE.LABEL.NO_PRICE' | translate }}</p>
  </div>

  <div class="align-content-center col-12 mx-lg-auto pb-5" *ngIf="offerEstimations.length > 0">
    <hr class="bary-hr" />
    <h2 #card class="pb-5 pt-4 text-center offer-title">{{ 'WEPAL_LIGHT_ESTIMATE.TITLE' | translate }}</h2>
    <div class="row no-gutters justify-content-center card-deck">
      <div class="d-flex justify-content-center col-12 col-md-6 col-lg-4 mb-4" *ngFor="let offerEstimation of offerEstimations" data-id-cypress="offer-estimation">
        <jhi-bary-pricing-pack [offerEstimation]="offerEstimation" (estimateEvent)="updateTransport($event.id)"></jhi-bary-pricing-pack>
      </div>
    </div>
  </div>
</section>
